import { Component, inject } from '@angular/core'
import { toSignal } from '@angular/core/rxjs-interop'
import { Router, RouterLink, RouterOutlet } from '@angular/router'
import { BricksIconComponent, BricksToolbarComponent, BricksUserMenuComponent } from '@enbw_bricks/ui'
import { AuthService } from '../auth/auth.service'
import { environment } from '../../../environments/environment'

@Component({
  selector: 'app-main-layout',
  imports: [BricksToolbarComponent, BricksUserMenuComponent, BricksIconComponent, RouterOutlet, RouterLink],
  styles: [
    `
      :host {
        display: flex;
        flex-direction: column;
        flex: 1 1 auto;
        min-height: 0;
      }
    `,
  ],
  template: `
    <bricks-app-toolbar
      [title]="'Batterie-Vermarktung'"
      [showCustomLogo]="false"
      [attributeLabel]="'Stage'"
      [attributeValue]="stagename"
      [attributeColor]="devMode ? 'error' : 'accent'"
      (homeClick)="navigateHome()">
      <bricks-icon app-logo [routerLink]="['/']" style="cursor: pointer">bricks-home</bricks-icon>

      <bricks-user-menu
        [userInfo1]="currentUser()?.email ?? '—'"
        userInfo2="Benutzer"
        [userInfo1Primary]="true"
        (logOut)="logout()">
      </bricks-user-menu>
    </bricks-app-toolbar>

    <router-outlet></router-outlet>
  `,
})
export class MainLayoutComponent {
  private readonly router = inject(Router)
  private readonly authService = inject(AuthService)

  readonly currentUser = toSignal(this.authService.currentUser$, { initialValue: null })
  readonly stagename = environment.name.toUpperCase()
  readonly devMode = !environment.production

  navigateHome(): void {
    void this.router.navigate(['/'])
  }

  async logout(): Promise<void> {
    await this.authService.logout()
  }
}
